import { __require as require_getNative } from './_getNative.js';
import { __require as require_root } from './_root.js';

var _WeakMap;
var hasRequired_WeakMap;

function require_WeakMap () {
	if (hasRequired_WeakMap) return _WeakMap;
	hasRequired_WeakMap = 1;
	var getNative = require_getNative(),
	    root = require_root();

	/* Built-in method references that are verified to be native. */
	var WeakMap = getNative(root, 'WeakMap');

	_WeakMap = WeakMap;
	return _WeakMap;
}

export { require_WeakMap as __require };
//# sourceMappingURL=_WeakMap.js.map
